import {
  GOOD_SALARY,
  LOW_SALARY,
} from 'src/app/shared/constants/salaryFeedback';

export default (
  maximumSalaryValue?: number | null,
  minimumSalaryValue?: number | null,
  recommendedSalaryMaximum?: number,
  recommendedSalaryMinimum?: number,
): string => {
  if (
    !recommendedSalaryMaximum ||
    !recommendedSalaryMinimum ||
    !maximumSalaryValue
  ) {
    return '';
  }

  if (maximumSalaryValue && (minimumSalaryValue || minimumSalaryValue === 0)) {
    if (
      minimumSalaryValue < recommendedSalaryMinimum &&
      maximumSalaryValue < recommendedSalaryMinimum
    ) {
      return LOW_SALARY;
    }

    if (
      minimumSalaryValue < recommendedSalaryMinimum &&
      maximumSalaryValue >= recommendedSalaryMinimum
    ) {
      return '';
    }

    return GOOD_SALARY;
  }

  if (minimumSalaryValue || minimumSalaryValue === 0) {
    return minimumSalaryValue >= recommendedSalaryMinimum
      ? GOOD_SALARY
      : LOW_SALARY;
  }

  return '';
};
